import { render, staticRenderFns } from "./CaseMenu.vue?vue&type=template&id=f0e608aa"
import script from "./CaseMenu.vue?vue&type=script&lang=js"
export * from "./CaseMenu.vue?vue&type=script&lang=js"
import style0 from "./CaseMenu.vue?vue&type=style&index=0&id=f0e608aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports